import React from 'react';
// import { Link } from 'gatsby';
import { Typography } from '../../../atoms/typography/Typography';
import { Row } from '../../../atoms/row/Row';
import { Checkbox } from '../../../atoms/checkbox/Checkbox';
import { cnMerge } from '../../../../utils/utils';

const PrivacyCheckbox = ({
  id = 'privacy-checkbox',
  checked,
  error,
  privacyLink,
  termsLink,
  onClick,
  required,
  className,
  t,
}) => (
  <Row className={cnMerge(className, 'gap-2')}>
    <Checkbox
      id={id}
      checked={checked}
      onChange={onClick}
      className="bg-transparent"
      error={error}
    />
    <Typography htmlFor={id} as="label" textAlign="left" fontVariant="sm">
      {t('formCommon.iAccept')}
      {privacyLink && termsLink && (
        <>
          <a
            href={privacyLink}
            title="privacy policy"
            className="text-primary-500 mx-1 underline global-hover"
            target="_blank"
          >
            Privacy Policy
          </a>
          {t('formCommon.and')}
          <a
            href={termsLink}
            title="terms of use"
            className="text-primary-500 ml-1 underline global-hover"
            target="_blank"
          >
            Terms of use
          </a>
        </>
      )}
      <span className={`${!required && 'hidden'}`}> *</span>
    </Typography>
  </Row>
);

export default PrivacyCheckbox;
